import resume from '../assets/pdf/resume.pdf'
import  Tarek from '../jpg/Tarek.jpeg'
export const headerData = {
    name: 'Tarek Yosry',
    title: "Full-Stack Web Developer",
    desciption:"I can help you build a product, feature or website. Look through some of my work and experience! If you like what you see and have a project you need coded, don't hesitate to contact me.",
    image: Tarek,
    resumePdf: resume
}
